import React from 'react';
import { classNames } from '../../utils/class-names';

export class CircularProgressBar extends React.Component<{
  total: number;
  current: number;
  removeLabel?: boolean;
  /** When true (default) the bar dims to 70% and brightens on hover. */
  dimmed?: boolean;
  /** Utility classes for the "done" dots (defaults to the brand secondary). */
  doneClassName?: string;
  /** Utility classes for the "pending" dots. */
  pendingClassName?: string;
}> {
  render() {
    const {
      dimmed = true,
      doneClassName = 'bg-secondary',
      pendingClassName = 'bg-gray-500',
    } = this.props;
    const delta = this.props.total - this.props.current;
    const done = [];
    for (let i = 0; i < this.props.current; ++i) done.push(i);
    const pending = [];
    for (let i = 0; i < delta; ++i) pending.push(i);
    let indexCount = 0;
    return (
      <div
        className={classNames(
          'flex flex-row items-center',
          dimmed && 'opacity-70 hover:opacity-100'
        )}
      >
        {this.props.removeLabel === false && (
          <label className="mr-[5px] font-['Ubuntu'] text-[12px] font-light tracking-[0.5px]">
            using
          </label>
        )}
        {done.map(_ => (
          <div
            key={indexCount++}
            className={classNames('mx-0.5 h-[15px] w-[15px] rounded-full', doneClassName)}
          />
        ))}
        {pending.map(_ => (
          <div
            key={indexCount++}
            className={classNames('mx-0.5 h-[15px] w-[15px] rounded-full', pendingClassName)}
          />
        ))}
      </div>
    );
  }
}
